<a href="#index_main" pageScroll title="{{'guideTile.middle' | translate}}" class="key" accesskey="C">:::</a>
<div  class="notfound0" [class.web-content-notfound]="!isRoot404">
  <img class="mask404 fit_cover" src="/assets/images/mask-s.webp" #hideimage alt="{{'webpageNotFound'|translate}}">
  <div class="gears">
    <div class="gears_big">
      <img class="spin" src="/assets/images/gear-b.webp" alt="大齒輪"/>
    </div>
    <div class="gears_small">
      <img  class="spin-back" src="/assets/images/gear-s.webp" alt="小齒輪"/>
    </div>
  </div>
  <div class="title_center">
    <h2 class="ml2">  PAGE NOT FOUND </h2>
  </div>
</div>


